import { isEqual } from "lodash";
import { createDirtyChecker } from "../gvc/testNewForm/createDirtyChecker";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, (x) => x, (i, v) => {
    const dirty: Record<string, boolean> = {};
    if (!isEqual(i.account, v.account)) dirty.account = true;
    if (!isEqual(i.address, v.address)) dirty.address = true;
    if (!isEqual(i.users, v.users)) dirty.users = true;
    if (!isEqual(i.alert, v.alert)) dirty.alert = true;
    return dirty;
  });
}
